import type { HallResponse } from '~/types/on24-klient'
import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { usePageQuery } from './shared'

const query = (path: string, currentPage: Ref<number>, sortOrder: Ref<string>, filters: Ref<Record<string, string | string[]>>, adopter: Ref<string | undefined>) => {
  const app = useNuxtApp()

  return useQuery({
    queryKey: ['hall', path, currentPage, sortOrder, filters, adopter],
    queryFn: async () => {
      return await app.$api<HallResponse>(path, {
        query: {
          slk: currentPage.value,
          so: sortOrder.value,
          adopter: adopter.value,
          ...filters.value,
        },
      })
    },
    placeholderData: keepPreviousData,
  })
}

export const useHallQuery = usePageQuery(query)
